import SystemMeter from '@components/_shared/SystemMeter';
import WeatherWidget from '@components/Sun/WeatherWidget';
import DeviceListPage from '@src/components/_shared/devices/DeviceListPage';
import UnitList from '@src/components/_shared/UnitListContainer/UnitList';
import { Device } from '@src/types/Device';
import { DeviceType } from '@src/types/devices/DeviceConfig.types';
import { SiteMeta } from '@src/types/SiteMeta';
import storeConnector from '@store/storeConnector';
import { ReactElement } from 'react';

interface PCSProps {
  currentUnit: Device;
  siteMeta: SiteMeta;
}

function PCS({ currentUnit, siteMeta }: PCSProps): ReactElement {
  return (
    <div className='home-row'>
      <div className='fcol'>
        <SystemMeter />
        <UnitList />
      </div>
      <div className='fcol'>
        <DeviceListPage
          currentUnit={currentUnit}
          deviceType={DeviceType.PCS_PV}
          isUnitScope
        />
        <WeatherWidget hideForecast={!siteMeta.ui.WeatherForecast_enable} />
      </div>
    </div>
  );
}

export default storeConnector(PCS, {
  config: ['siteMeta'],
  service: ['currentUnit'],
});
